import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

const LANGUAGE_STORAGE_KEY = 'appLanguage';

function interpolate(str, vars) {
  if (!vars) return str;
  return Object.entries(vars).reduce(
    (acc, [key, value]) => acc.replaceAll(`{${key}}`, value),
    str,
  );
}

// Every hardcoded UI string across the app's top-level tab pages, in both
// supported languages. Deeper drill-down screens (booking wizard steps,
// personal-info/settings/help sub-screens, loyalty checkout/points-history)
// aren't covered yet — add keys here and call t() from there to extend.
const translations = {
  ru: {
    'common.loading': 'Загрузка…',
    'common.back': 'Назад',
    'common.loadError': 'Не удалось загрузить данные. Проверьте интернет и попробуйте снова.',
    'common.retry': 'Повторить',
    'subpay.checking': 'Проверяем оплату…',
    'subpay.checkError': 'Не удалось проверить статус оплаты.',
    'subpay.pendingTitle': 'Оплата обрабатывается',
    'subpay.declinedTitle': 'Оплата не прошла',
    'subpay.pendingBody': 'Подтверждение может занять немного времени. Подписка активируется автоматически, как только оплата будет подтверждена.',
    'subpay.declinedBody': 'Подписка не была активирована. Попробуйте оформить её ещё раз.',
    'subpay.failedTitle': 'Оплата не завершена',
    'subpay.retry': 'Повторить оплату',
    'subpay.retrying': 'Переходим к оплате…',
    'subpay.toMain': 'На главную',
    'subpay.close': 'Закрыть',
    'common.next': 'Далее',

    'programs.header': 'Программы восстановления',
    'programs.includes': 'Включает в себя услуги',
    'programs.effects': 'Эффекты',
    'programs.seeMore': 'Смотреть ещё',

    'menu.title': 'Меню',
    'menu.subtitle': 'Блюда и напитки можно выбрать и заказать на месте во время посещения клуба.',
    'menu.kitchen': 'Кухня',
    'menu.bar': 'Бар',
    'menu.all': 'Все',
    'menu.loadMore': 'Загрузить ещё',
    'menu.empty': 'В этой категории пока нет позиций',

    'news.header': 'О паре и восстановлении',
    'news.empty': 'Пока нет новостей',
    'news.allArticles': 'Все статьи',

    'services.header': 'Услуги',
    'services.pairsWith': 'Сочетается с',
    'services.mastersOfService': 'Мастера услуги',
    'services.empty': 'Здесь пока нет услуг',
    'services.notFound': 'Услуга не найдена',
    'programs.empty': 'Здесь пока нет программ',
    'programs.notFound': 'Программа не найдена',

    'masters.notFound': 'Мастер не найден',
    'masters.experienceTitle': 'Опыт и специализация',
    'masters.yearsExperience': '{n} лет опыта в банных процедурах. ',
    'masters.servicesTitle': 'Услуги мастера',

    'home.greeting.night': 'Доброй ночи',
    'home.greeting.morning': 'Доброе утро',
    'home.greeting.day': 'Добрый день',
    'home.greeting.evening': 'Добрый вечер',
    'home.notifications': 'Уведомления',
    'home.recoveryLabel': 'РИТМ ВОССТАНОВЛЕНИЯ',
    'home.bonusesLabel': 'БОНУСЫ',
    'home.eventOfDay': 'Событие дня',
    'home.weekRituals': 'Ритуалы недели',
    'home.weekday.0': 'ПОНЕДЕЛЬНИК',
    'home.weekday.1': 'ВТОРНИК',
    'home.weekday.2': 'СРЕДА',
    'home.weekday.3': 'ЧЕТВЕРГ',
    'home.weekday.4': 'ПЯТНИЦА',
    'home.weekday.5': 'СУББОТА',
    'home.weekday.6': 'ВОСКРЕСЕНЬЕ',
    'home.book': 'Забронировать',
    'home.clubPower': 'Ваше место силы',
    'home.clubPowerBody': 'С {year} года создаём условия для восстановления тела, разума и души через правильный пар и заботу команды.',
    'home.clubPowerBtn': 'Больше о клубе',
    'home.yearsExperience': 'ЛЕТ ОПЫТА',
    'home.rating': 'РЕЙТИНГ',
    'home.servicesStat': 'УСЛУГ',
    'home.recoveryPrograms': 'Программы восстановления',
    'home.recommended': 'РЕКОМЕНДУЕМ',
    'home.allPrograms': 'Все программы',
    'home.popularServices': 'Популярные услуги',
    'home.allServices': 'Все услуги',
    'home.kitchenTitle': 'Кухня и бар',
    'home.kitchenBody': 'Продолжите свой банный ритуал с блюдами и напитками из нашего меню.',
    'home.viewMenu': 'Смотреть меню',
    'home.minutes': 'мин',
    'home.hours': 'часа',

    'card.upcoming.pill': 'ПРЕДСТОЯЩИЙ ВИЗИТ',
    'card.upcoming.empty': 'У вас пока нет предстоящих визитов',
    'card.guestsSuffix': '{n} гостя',
    'card.club.pill': 'СЕГОДНЯ В КЛУБЕ',
    'card.club.empty': 'Сегодня нет специальной программы',
    'card.club.slotsAvailable': 'мест доступно',
    'card.club.nearestTime': 'Ближайшее время общего парения',
    'card.club.book': 'Забронировать место',
    'card.club.status.free': 'Спокойно и свободно',
    'card.club.status.filling': 'Заполняется',
    'card.club.status.full': 'Почти полно',
    'card.club.status.unknown': 'Загрузка уточняется',
    'card.repeat.pill': 'ПОВТОРИТЬ ПРОШЛЫЙ ВИЗИТ',
    'card.repeat.empty': 'Здесь появится ваш последний визит',
    'card.repeat.repeatBtn': 'Повторить',
    'card.repeat.reviewBtn': 'Оставить отзыв',

    'mybookings.header': 'Мои бронирования',
    'mybookings.paid': 'ОПЛАЧЕНО',
    'mybookings.prepay': 'ПРЕДОПЛАТА',
    'mybookings.change': 'Изменить',
    'mybookings.cancel': 'Отменить',
    'mybookings.repeatAria': 'Повторить визит',
    'mybookings.createNew': 'Создать новую бронь',
    'mybookings.modalTitle': 'Изменить бронирование можно через менеджера',
    'mybookings.modalBody':
      'Скорректируйте детали вашего визита вместе с менеджером. Он подберёт свободный вариант и пересчитает детали.',
    'mybookings.whatsapp': 'Написать в WhatsApp',
    'mybookings.hours': 'На связи ежедневно: 10:00–22:00',
    'mybookings.close': 'Закрыть',
    'mybookings.keepBooking': 'Оставить бронь',
    'mybookings.showAll': 'Показать все',
    'mybookings.collapse': 'Свернуть',

    'loyalty.cancelTitle': 'Отменить подписку?',
    'loyalty.cancelBody': 'После отмены неиспользованные посещения и клубные привилегии будут недоступны.',
    'loyalty.yesCancelBtn': 'Да, отменить',
    'loyalty.keepSubBtn': 'Оставить подписку',
    'loyalty.switchTitle': 'Перейти на {tier}?',
    'loyalty.switchBody':
      'При смене подписки неиспользованные посещения и привилегии текущего плана будут недоступны.',
    'loyalty.yesSwitchBtn': 'Да, перейти',
    'loyalty.keepCurrentBtn': 'Оставить текущую',
    'loyalty.hero': 'Клуб лояльности',
    'loyalty.untilNextTier': 'До {tier} {n} {word}',
    'loyalty.pointsSub': '1 балл = 1 тенге',
    'bonus.updatedJustNow': 'Обновлено: только что',
    'bonus.updatedAt': 'Обновлено в {time}',
    'bonus.updatedOn': 'Обновлено {date} в {time}',
    'bonus.staleFailed': 'Данные на {when} · Не удалось обновить',
    'bonus.staleOld': 'Данные на {when} · Могут быть неактуальными',
    'bonus.unavailable': 'Не удалось получить баланс',
    'bonus.notFound': 'Бонусный счёт не найден',
    'bonus.ambiguous': 'Не удалось однозначно определить ваш бонусный счёт. Обратитесь к администратору клуба.',
    'bonus.noWallet': 'Бонусная программа не подключена',
    'bonus.multiple': 'Подключено несколько бонусных программ',
    'bonus.noPhone': 'Укажите номер телефона в профиле',
    'bonus.spendAtCashier': 'Бонусы можно потратить на кассе клуба',
    'retention.fromClub': 'Сообщение от 888',
    'retention.open': 'Открыть',
    'retention.dismiss': 'Закрыть',
    'retention.consentTitle': 'Напоминания и приглашения',
    'retention.consentBody': 'Присылать вам редкие напоминания и приглашения 888? Отключить можно в любой момент в профиле.',
    'retention.consentYes': 'Да, присылать',
    'retention.consentLater': 'Не сейчас',
    'bonus.rules': '1 бонус = 1 ₸ · кешбэк 1% · бонусами можно оплатить до 20%',
    'bonus.pending.WELCOME': 'Приветственные {amount} бонусов ожидают зачисления',
    'bonus.pending.CASHBACK': 'Кешбэк {amount} бонусов ожидает зачисления',
    'bonus.pending.REFUND': 'Возврат {amount} бонусов ожидает зачисления',
    'bonus.pending.REDEEM': 'Списание {amount} бонусов в обработке',
    'bonus.pending.ADJUSTMENT': 'Корректировка {amount} бонусов в обработке',
    'bonus.kind.WELCOME': 'Приветственный бонус',
    'bonus.kind.CASHBACK': 'Кешбэк 1%',
    'bonus.kind.REDEEM': 'Оплата бонусами',
    'bonus.kind.REFUND': 'Возврат бонусов',
    'bonus.kind.ADJUSTMENT': 'Корректировка',
    'bonus.state.PENDING': 'Ожидает',
    'bonus.state.FAILED': 'Не выполнено',
    'bonus.state.BLOCKED': 'Требует проверки',
    'bonus.state.SKIPPED': 'Уже начислено',
    'bonus.state.CANCELLED': 'Отменено',
    'bonus.redeem.available': 'Доступно бонусов',
    'bonus.redeem.upTo': 'Можно использовать: до {n} бонусов',
    'bonus.redeem.limit': 'не более 20% стоимости',
    'bonus.redeem.use': 'Списать бонусы',
    'bonus.redeem.payable': 'К оплате',
    'bonus.redeem.none': 'Бонусов для списания пока нет',
    'bonus.redeem.unavailable': 'Не удалось подтвердить баланс бонусов. Списание временно недоступно.',
    'bonus.redeem.ambiguous': 'Бонусный счёт определён неоднозначно — списание недоступно.',
    'bonus.reserveFailed': 'Не удалось зарезервировать бонусы. Повторите попытку или оплатите без бонусов.',
    'bonus.payWithoutBonus': 'Оплатить без бонусов',
    'bonus.refresh': 'Обновить',
    'bonus.refreshing': 'Обновляем…',
    'loyalty.historyBtn': 'История баллов',
    'loyalty.historyEmpty': 'Пока нет операций с баллами',
    'loyalty.historyError': 'Не удалось загрузить историю. Попробуйте ещё раз.',
    'loyalty.historyToday': 'Сегодня',
    'loyalty.historyYesterday': 'Вчера',
    'loyalty.historyPointsUnit': 'баллов',
    'loyalty.activeSub': 'Активная подписка',
    'loyalty.visitsRemaining': 'Осталось посещений',
    'loyalty.unlimited': 'Безлимит',
    'loyalty.daysRemaining': 'Осталось дней',
    'loyalty.autoRenewOn': 'Автопродление включено',
    'loyalty.autoRenewAria': 'Автопродление',
    'loyalty.cancelSubBtn': 'Отменить подписку',
    'loyalty.subscriptions': 'Клубные подписки',
    'loyalty.perMonth': ' · месяц',
    'loyalty.currentPlan': 'Текущий план',
    'loyalty.choose': 'Выбрать',
    'loyalty.faqTitle': 'Частые вопросы',
    'loyalty.faq.q1': 'Как начисляются бонусы?',
    'loyalty.faq.a1':
      'Бонусы начисляются автоматически после каждого оплаченного визита — процент зависит от суммы чека и вашего клубного статуса.',
    'loyalty.faq.q2': 'Как использовать бонусы?',
    'loyalty.faq.a2':
      'Баллами можно оплатить часть визита или клубную подписку — переключатель появится в момент оформления.',
    'loyalty.faq.q3': 'Когда обновляется мой уровень?',
    'loyalty.faq.a3':
      'Уровень (Silver/Gold/Platinum) пересчитывается автоматически после каждого визита на основе общего числа посещений.',
    'loyalty.faq.q4': 'Что входит в подписку?',
    'loyalty.faq.a4':
      'Каждый тариф даёт фиксированное число визитов в месяц (или безлимит), скидки и бонусы за визит — подробности указаны в карточке тарифа.',
    'loyalty.faq.q5': 'Когда списываются посещения по подписке?',
    'loyalty.faq.a5': 'Посещение списывается в момент визита в клуб, если оно предусмотрено вашим тарифом.',
    'loyalty.faq.q6': 'Можно ли оплатить подписку бонусами?',
    'loyalty.faq.a6':
      'Да, доступные баллы можно применить при оформлении — переключатель «Использовать баллы» на экране оплаты.',
    'loyalty.faq.q7': 'Что будет, если отменить подписку?',
    'loyalty.faq.a7': 'Неиспользованные посещения и клубные привилегии станут недоступны сразу после отмены.',
    'loyalty.faq.q8': 'Как включить или отключить автопродление?',
    'loyalty.faq.a8': 'Переключатель «Автопродление» находится в карточке активной подписки на этом экране.',
    'loyalty.faq.q9': 'Можно ли изменить подписку?',
    'loyalty.faq.a9':
      'Да, выберите другой тариф в списке ниже — при смене плана мы предупредим, что текущие привилегии сгорят.',

    'activity.badge.high': 'ВЫСОКИЙ',
    'activity.heading.high': 'Ваш ритм восстановления сейчас высокий.',
    'activity.body.high': 'Чтобы поддержать его, рекомендуем вернуться в течение 5–7 дней.',
    'activity.badge.medium': 'СРЕДНИЙ',
    'activity.heading.medium': 'Ваш ритм восстановления сейчас средний.',
    'activity.body.medium': 'Чтобы улучшить его, рекомендуем вернуться в течение 3–5 дней.',
    'activity.badge.low': 'НИЗКИЙ',
    'activity.unknownBadge': 'НЕТ ДАННЫХ',
    'activity.unknownHeading': 'Мы пока не видим ваши визиты.',
    'activity.unknownBody': 'Назовите на ресепшене номер телефона из приложения — мы привяжем ваши посещения, и здесь появится ваш ритм.',
    'activity.heading.low': 'Ваш ритм восстановления сейчас низкий.',
    'activity.body.low': 'Чтобы восстановить его, рекомендуем вернуться как можно скорее.',
    'activity.infoText1': 'Ритм основан на ваших визитах за последние 3 месяца.',
    'activity.infoText2': 'Регулярные посещения помогают поддерживать высокий уровень восстановления.',
    'activity.infoAria': 'Подробнее',
    'activity.hero': 'Ритм восстановления',
    'activity.visits3moLine1': 'ВИЗИТОВ ЗА',
    'activity.visits3moLine2': '3 МЕСЯЦА',
    'activity.currentStreakLine1': 'ТЕКУЩАЯ',
    'activity.currentStreakLine2': 'СЕРИЯ',
    'activity.totalVisitsLine1': 'ВСЕГО',
    'activity.totalVisitsLine2': 'ВИЗИТОВ',
    'activity.thisWeekSuffix': 'за неделю. Так держать!',
    'activity.personalRec': 'ПЕРСОНАЛЬНАЯ РЕКОМЕНДАЦИЯ',
    'activity.personalRecText': 'По вашей истории лучше всего подойдёт программа «{program}»',
    'activity.recommendationsTitle': 'Рекомендации для восстановления',
    'activity.allPrograms': 'Все программы восстановления',
    'activity.visits.many': '{n} посещений',
    'activity.visits.one': '{n} посещение',
    'activity.visits.few': '{n} посещения',
    'activity.recoverySuffix': 'восстановления',
    'activity.and': ' и ',

    'profile.subActive': 'АКТИВНАЯ ПОДПИСКА',
    'profile.subExpiring': 'ПОДПИСКА СКОРО ЗАКОНЧИТСЯ',
    'profile.subExpired': 'ПОДПИСКА ЗАКОНЧИЛАСЬ',
    'profile.visitsRemaining': 'осталось посещений',
    'profile.daysRemaining': 'осталось дней',
    'profile.expiredBody': 'Продлите подписку, чтобы снова бронировать визиты и программы на клубных условиях.',
    'profile.autoRenewOn': 'Автопродление включено',
    'profile.autoRenewAria': 'Автопродление',
    'profile.renew': 'Продлить',
    'profile.visitFallback': 'Визит',
    'profile.guestsSuffix': '{n} гостя',
    'profile.pastVisit': 'ПРОШЛЫЙ ВИЗИТ',
    'profile.repeatAria': 'Повторить визит',
    'profile.repeat': 'Повторить',
    'profile.leaveReview': 'Оставить отзыв',
    'profile.tile.personalInfo': 'Мои данные',
    'profile.tile.settings': 'Настройки',
    'profile.tile.feedback': 'Обратная связь',
    'profile.tile.help': 'Помощь',
    'profile.tile.logout': 'Выйти',
    'profile.deleteTitle': 'Удалить аккаунт?',
    'profile.deleteBody':
      'Аккаунт, история посещений и бонусы будут удалены. Восстановить их после удаления не получится.',
    'profile.deleteConfirm': 'Удалить аккаунт',
    'profile.cancel': 'Отмена',
    'profile.notifications': 'Уведомления',
    'profile.recoveryLabel': 'РИТМ ВОССТАНОВЛЕНИЯ',
    'profile.bonusesLabel': 'БОНУСЫ',
    'profile.historyTitle': 'История посещений',
    'profile.upcomingTab': 'Предстоящие',
    'profile.pastTab': 'Прошедшие',
    'profile.pay.paid': 'Оплачено',
    'profile.pay.prepaid': 'Предоплата внесена',
    'profile.pay.unpaid': 'Не оплачено',
    'profile.pay.free': 'Без оплаты',
    'profile.pay.pending': 'Ожидает оплаты',
    'profile.pay.declined': 'Оплата не прошла',
    'profile.pay.button': 'Оплатить',
    'profile.pay.opening': 'Открываем…',
    'profile.pay.failed': 'Не удалось открыть оплату. Попробуйте ещё раз.',
    'profile.noUpcoming': 'У вас пока нет предстоящих визитов',
    'profile.noPast': 'Здесь появится история ваших визитов',
    'profile.loadMore': 'Загрузить ещё',
    'profile.logoutTitle': 'Выйти из аккаунта?',
    'profile.logoutBody': 'Вы сможете снова войти по номеру телефона.',
    'profile.logoutConfirm': 'Выйти из приложения',
    'profile.deleteAccountAria': 'Удалить аккаунт',

    'profile.settings.bookingReminders': 'Напоминания о брони',
    'profile.settings.promoNews': 'Акции и новости',
    'profile.settings.appSection': 'Приложение',
    'profile.settings.language': 'Язык',
    'profile.settings.appVersion': 'Версия приложения',

    'profile.help.title': 'Связаться с нами',
    'profile.help.faqTitle': 'Частые вопросы',
    'profile.help.faq.q1': 'Как забронировать визит?',
    'profile.help.faq.a1':
      'Откройте вкладку «Бронь», выберите зал, дату и время — бронирование подтвердится сразу после оплаты или внесения предоплаты.',
    'profile.help.faq.q2': 'Как отменить бронирование?',
    'profile.help.faq.a2':
      'Изменить или отменить бронь можно через менеджера — свяжитесь с нами в WhatsApp или по телефону, указанным выше.',
    'profile.help.faq.q3': 'Где посмотреть мои бонусы?',
    'profile.help.faq.a3': 'Баланс бонусов отображается на главном экране профиля и в разделе «Клуб лояльности».',
    'profile.help.faq.q4': 'Как работает система уровней?',
    'profile.help.faq.a4':
      'Уровень (Silver/Gold/Platinum) пересчитывается автоматически на основе общего числа посещений за месяц.',
    'profile.help.faq.q5': 'Как активировать подписку?',
    'profile.help.faq.a5':
      'В разделе «Клуб лояльности» выберите тариф и оформите подписку — она активируется сразу после оплаты.',

    'profile.feedback.title': 'Поделитесь обратной связью',
    'profile.feedback.intro':
      'Расскажите, что вам понравилось или что можно улучшить. Мы внимательно читаем отзывы и используем их, чтобы делать клуб и сервис лучше.',
    'profile.feedback.ratingLabel': 'Ваша оценка',
    'profile.feedback.starAria': '{n} из 5',
    'profile.feedback.impressionLabel': 'Общее впечатление',
    'profile.feedback.impressionPlaceholder': 'Ваше мнение',
    'profile.feedback.recommendationsLabel': 'Ваши рекомендации',
    'profile.feedback.recommendationsPlaceholder': 'Что можно улучшить',
    'profile.feedback.sending': 'Отправка…',
    'profile.feedback.submit': 'Отправить',
    'profile.feedback.thanksTitle': 'Спасибо, что поделились',
    'profile.feedback.thanksBody':
      'Ваш отзыв уже у нас. Мы внимательно относимся к таким сообщениям — они помогают сохранять заботу, качество и атмосферу клуба.',
    'profile.feedback.thanksBtn': 'На главную',

    'profile.personalInfo.title': 'Личная информация',
    'profile.personalInfo.firstName': 'Имя',
    'profile.personalInfo.lastName': 'Фамилия',
    'profile.personalInfo.notSet': 'Не указан',
    'profile.personalInfo.genderMale': 'Мужской',
    'profile.personalInfo.genderFemale': 'Женский',
    'profile.personalInfo.saving': 'Сохранение…',
    'profile.personalInfo.save': 'Сохранить изменения',

    'profile.notificationsEmpty': 'У вас пока нет уведомлений',
    'profile.languageTitle': 'Выберите язык интерфейса',
    'profile.tierBase': 'Старт',

    'booking.hall.title': 'Выберите тип зала',
    'booking.hall.subtitle':
      'Подберите формат отдыха: в общей атмосфере клуба или в приватном пространстве.',
    'booking.hall.standardTitle': 'Общий зал',
    'booking.hall.standardSubtitle': 'Классическая атмосфера, банная компания, коллективный дух',
    'booking.hall.vipTitle': 'VIP-зал',
    'booking.hall.vipSubtitle': 'Приватное пространство, персональный мастер',
    'booking.hall.selectPrompt': 'Выберите зал',

    'booking.datetime.title': 'Дата и время',
    'booking.datetime.availableTime': 'Доступное время',
    'booking.datetime.noSlots': 'Нет доступных слотов',
    'booking.datetime.selectTime': 'Выберите время',
    'booking.datetime.pickDate': 'Сначала выберите дату',
    'booking.datetime.loadError': 'Не удалось загрузить время. Попробуйте ещё раз.',
    'booking.datetime.noSlotsToday': 'На эту дату свободного времени нет',
    'booking.datetime.leadNote': 'Бронь возможна не позднее чем за {n} мин до начала',
    'booking.datetime.duration': 'На сколько часов',
    'booking.datetime.hoursShort': '{n} ч',
    'booking.guests.maxTotal': 'Максимум {n} человек в одной брони (взрослые и дети)',
    'booking.program.skip': 'Продолжить без услуг',
    'booking.review.noExtras': 'Без дополнительных услуг',
    'booking.review.hallCost': 'Аренда зала',
    'booking.review.burnNote': 'Если до начала брони осталось меньше 3 часов, оплата не возвращается — ни полная, ни предоплата.',

    'booking.guests.title': 'Сколько будет гостей?',
    'booking.guests.adults': 'Взрослые',
    'booking.guests.children': 'Дети',
    'booking.guests.fewerAdults': 'Меньше взрослых',
    'booking.guests.moreAdults': 'Больше взрослых',
    'booking.guests.fewerChildren': 'Меньше детей',
    'booking.guests.moreChildren': 'Больше детей',
    'booking.guests.maxAdults': 'Максимум {n} гостя',
    'booking.guests.maxChildren': 'Максимум {n} детей',

    'booking.program.title': 'Выберите программу восстановления или отдельные услуги',
    'booking.program.tabPrograms': 'Программы',
    'booking.program.tabServices': 'Услуги',
    'booking.program.empty': 'Программы пока не добавлены',
    'booking.program.hit': 'ХИТ',
    'booking.program.vipHallBadge': 'VIP-ЗАЛ',
    'booking.program.servicesEmpty': 'Услуги не найдены',
    'booking.program.categoryAll': 'Все',
    'booking.program.selectProgram': 'Выберите программу',
    'booking.program.selectServices': 'Выберите услуги',
    'booking.program.minutesShort': 'мин',
    'booking.program.vipModalTitle': 'Программа доступна в VIP-зале',
    'booking.program.vipModalBody':
      '«{name}» проводится в приватном формате с персональным мастером, поэтому доступна только при выборе VIP-зала.',
    'booking.program.ok': 'Хорошо',
    'booking.program.changeHall': 'Изменить зал',
    'booking.program.selectedOne': 'Выбрана {n} услуга',
    'booking.program.selectedFew': 'Выбрано {n} услуги',
    'booking.program.selectedMany': 'Выбрано {n} услуг',

    'booking.review.title': 'Проверьте детали',
    'booking.review.payFull': 'Оплатить 100%',
    'booking.review.payPrepayment': 'Внести предоплату',
    'booking.review.paymentNote':
      'Можно оплатить всю сумму сейчас или внести предоплату 30%. Остаток оплачивается на месте или через менеджера.',
    'booking.review.payModeSubscription': 'Списать с подписки',
    'booking.review.subVisitsRemainingPrefix': 'Осталось',
    'booking.review.subVisitsRemainingCount': '{n} посещения',
    'booking.review.payModeSeparate': 'Оплатить отдельно',
    'booking.review.payModeSeparateNote':
      'Вы можете оплатить полностью или внести предоплату в размере 30% от общей суммы',
    'booking.review.subscriptionRedeemNote': 'Спишем 1 посещение с клубной подписки',
    'booking.review.subscriptionRedeemNoteDiscount':
      'Спишем 1 посещение с клубной подписки — скидка {percent}% на программу и услуги',
    'booking.review.managerSheetTitle': 'Списание доступно через менеджера',
    'booking.review.managerSheetBullet1':
      'При бронировании на 2 и более человек списать посещение с подписки внутри приложения нельзя.',
    'booking.review.managerSheetBullet2':
      'Сейчас вы можете оплатить заказ полностью или внести задаток. После отправки заявки менеджер свяжется с вами, спишет ваше посещение с подписки и рассчитает сумму доплаты.',
    'booking.review.managerSheetGotIt': 'Понятно',
    'booking.review.hallLabel': 'Зал',
    'booking.review.dateLabel': 'Дата',
    'booking.review.timeLabel': 'Время',
    'booking.review.guestsLabel': 'Гости',
    'booking.review.programLabel': 'Программа',
    'booking.review.totalLabel': 'Итого к оплате',
    'booking.review.hallStandard': 'Общий зал',
    'booking.review.hallVip': 'VIP-зал',
    'booking.review.guestsWord': 'человека',
    'booking.review.childrenSuffix': ', {n} детей',
    'booking.review.promoPlaceholder': 'Введите промокод',
    'booking.review.useBonus': 'Использовать',
    'booking.review.bonusPoints': '{n} балла',
    'booking.review.useBonusAria': 'Использовать бонусные баллы',
    'booking.review.submitting': 'Отправляем…',
    'booking.review.submit': 'Перейти к оплате',

    'booking.payment.checking': 'Проверяем оплату…',
    'booking.payment.checkError':
      'Не удалось проверить статус оплаты. Свяжитесь с клубом, если деньги были списаны.',
    'booking.payment.successTitle': 'Оплата прошла успешно',
    'booking.payment.pendingTitle': 'Бронирование создано',
    'booking.payment.declinedTitle': 'Оплата отклонена',
    'booking.payment.successBody': 'Мы сохранили детали вашего визита. До встречи в клубе!',
    'booking.payment.pendingBody':
      'Мы подтверждаем оплату — это может занять пару минут. Мы свяжемся с вами, если потребуется.',
    'booking.payment.declinedBody': 'Оплата не прошла. Попробуйте ещё раз или свяжитесь с клубом.',
    'booking.payment.done': 'Готово',
    'booking.payment.redirecting': 'Переходим к оплате…',
    'booking.payment.notCompletedTitle': 'Оплата не завершена',
    'booking.payment.notCompletedBody':
      'Бронирование сохранено, но оплата не прошла. Вы можете попробовать снова.',
    'booking.payment.retry': 'Попробовать снова',
    'booking.payment.close': 'Закрыть',

    'club.addressLabel': 'Адрес',
    'club.addressLine1': 'Улица Жанайдар Жирентаев, 3',
    'club.addressLine2': 'Алматы район, Астана, Z00Y3E8',
    'club.hoursLabel': 'Режим работы',
    'club.hoursLine1': 'пн: 12:00–22:00',
    'club.hoursLine2': 'вт-пт: 11:00–22:00',
    'club.hoursLine3': 'сб-вс: 10:00–22:00',
    'club.description':
      'Club 888 — это бани у дома, где забота о себе становится регулярным ритуалом. ' +
      'С 2010 года мы создаём пространство для правильного пара, тепла и внимательного сервиса. ' +
      'Место, куда приходят восстановиться после насыщенного дня, провести время с близкими и вернуться к себе.',
    'club.powerCardTitle': 'Место силы',
    'club.powerCardBody':
      'К нам приходит восстановить тело, освободить голову от суеты и провести время в тёплой, спокойной атмосфере.',
    'club.atmosphereBadge': 'АТМОСФЕРА КЛУБА',
    'club.directionsTitle': 'Как до нас добраться',
    'club.buildRoute': 'Построить маршрут',
    'club.contactsTitle': 'Контакты',
    'club.whatsapp': 'Написать в WhatsApp',
    'club.recordsTitle': 'Рекорды клуба',
    'club.numbersTitle': '888 в цифрах',
    'club.storiesTitle': 'Истории, которые начались здесь',
    'club.estimatedNote': 'Оценочные показатели — рассчитаны по времени работы клуба',
    'club.noData': 'Нет данных',
    'club.num.years': 'Лет истории',
    'club.num.rating': 'Рейтинг клуба',
    'club.num.guests': 'Гостей за месяц',
    'club.num.guestsTotal': 'Гостей за всё время',
    'club.num.hours': 'Часов восстановления',
    'club.num.steamings': 'Проведено парений',
    'club.num.kvas': 'Кваса выпито, л',
    'club.cat.business': 'Бизнес',
    'club.cat.acquaintance': 'Знакомства',
    'club.cat.likeminded': 'Единомышленники',
    'club.cat.family': 'Семья',
    'club.cat.recovery': 'Отдых',
  },
  kk: {
    'common.loading': 'Жүктелуде…',
    'common.back': 'Артқа',
    'common.loadError': 'Деректерді жүктеу мүмкін болмады. Интернетті тексеріп, қайталаңыз.',
    'common.retry': 'Қайталау',
    'subpay.checking': 'Төлем тексерілуде…',
    'subpay.checkError': 'Төлем күйін тексеру мүмкін болмады.',
    'subpay.pendingTitle': 'Төлем өңделуде',
    'subpay.declinedTitle': 'Төлем өтпеді',
    'subpay.pendingBody': 'Растау аз уақыт алуы мүмкін. Төлем расталған бойда жазылым автоматты түрде іске қосылады.',
    'subpay.declinedBody': 'Жазылым белсендірілмеді. Қайта рәсімдеп көріңіз.',
    'subpay.failedTitle': 'Төлем аяқталмады',
    'subpay.retry': 'Төлемді қайталау',
    'subpay.retrying': 'Төлемге өтудеміз…',
    'subpay.toMain': 'Басты бетке',
    'subpay.close': 'Жабу',
    'common.next': 'Келесі',

    'programs.header': 'Қалпына келу бағдарламалары',
    'programs.includes': 'Қызметтерді қамтиды',
    'programs.effects': 'Әсерлері',
    'programs.seeMore': 'Тағы да қарау',

    'menu.title': 'Мәзір',
    'menu.subtitle': 'Тағамдар мен сусындарды клубқа келген кезде таңдап, тапсырыс беруге болады.',
    'menu.kitchen': 'Ас үй',
    'menu.bar': 'Бар',
    'menu.all': 'Барлығы',
    'menu.loadMore': 'Тағы да жүктеу',
    'menu.empty': 'Бұл санатта әзірге позициялар жоқ',

    'news.header': 'Буу және қалпына келу туралы',
    'news.empty': 'Әзірге жаңалықтар жоқ',
    'news.allArticles': 'Барлық мақалалар',

    'services.header': 'Қызметтер',
    'services.pairsWith': 'Үйлесімді',
    'services.mastersOfService': 'Қызмет шеберлері',
    'services.empty': 'Мұнда әзірге қызметтер жоқ',
    'services.notFound': 'Қызмет табылмады',
    'programs.empty': 'Мұнда әзірге бағдарламалар жоқ',
    'programs.notFound': 'Бағдарлама табылмады',

    'masters.notFound': 'Шебер табылмады',
    'masters.experienceTitle': 'Тәжірибе және мамандандыру',
    'masters.yearsExperience': 'Банное рәсімдерінде {n} жыл тәжірибе. ',
    'masters.servicesTitle': 'Шебердің қызметтері',

    'home.greeting.night': 'Қайырлы түн',
    'home.greeting.morning': 'Қайырлы таң',
    'home.greeting.day': 'Қайырлы күн',
    'home.greeting.evening': 'Қайырлы кеш',
    'home.notifications': 'Хабарландырулар',
    'home.recoveryLabel': 'ҚАЛПЫНА КЕЛУ ЫРҒАҒЫ',
    'home.bonusesLabel': 'БОНУСТАР',
    'home.eventOfDay': 'Күн оқиғасы',
    'home.weekRituals': 'Апта ритуалдары',
    'home.weekday.0': 'ДҮЙСЕНБІ',
    'home.weekday.1': 'СЕЙСЕНБІ',
    'home.weekday.2': 'СӘРСЕНБІ',
    'home.weekday.3': 'БЕЙСЕНБІ',
    'home.weekday.4': 'ЖҰМА',
    'home.weekday.5': 'СЕНБІ',
    'home.weekday.6': 'ЖЕКСЕНБІ',
    'home.book': 'Брондау',
    'home.clubPower': 'Сіздің күш орныңыз',
    'home.clubPowerBody': '{year} жылдан бері дене, ақыл-ой және жанды қалпына келтіру үшін дұрыс буу мен команданың қамқорлығы арқылы жағдай жасаймыз.',
    'home.clubPowerBtn': 'Клуб туралы көбірек',
    'home.yearsExperience': 'ТӘЖІРИБЕ ЖЫЛДАРЫ',
    'home.rating': 'РЕЙТИНГ',
    'home.servicesStat': 'ҚЫЗМЕТ',
    'home.recoveryPrograms': 'Қалпына келу бағдарламалары',
    'home.recommended': 'ҰСЫНАМЫЗ',
    'home.allPrograms': 'Барлық бағдарламалар',
    'home.popularServices': 'Танымал қызметтер',
    'home.allServices': 'Барлық қызметтер',
    'home.kitchenTitle': 'Асхана және бар',
    'home.kitchenBody': 'Банное рәсімін мәзіріміздегі тағамдар мен сусындармен жалғастырыңыз.',
    'home.viewMenu': 'Мәзірді қарау',
    'home.minutes': 'мин',
    'home.hours': 'сағат',

    'card.upcoming.pill': 'АЛДАҒЫ САПАР',
    'card.upcoming.empty': 'Сізде әзірге алдағы сапарлар жоқ',
    'card.guestsSuffix': '{n} қонақ',
    'card.club.pill': 'БҮГІН КЛУБТА',
    'card.club.empty': 'Бүгін арнайы бағдарлама жоқ',
    'card.club.slotsAvailable': 'орын қолжетімді',
    'card.club.nearestTime': 'Жақын арадағы жалпы буу уақыты',
    'card.club.book': 'Орын брондау',
    'card.club.status.free': 'Тыныш және бос',
    'card.club.status.filling': 'Толуда',
    'card.club.status.full': 'Дерлік толы',
    'card.club.status.unknown': 'Жүктеме нақтылануда',
    'card.repeat.pill': 'СОҢҒЫ САПАРДЫ ҚАЙТАЛАУ',
    'card.repeat.empty': 'Мұнда соңғы сапарыңыз көрсетіледі',
    'card.repeat.repeatBtn': 'Қайталау',
    'card.repeat.reviewBtn': 'Пікір қалдыру',

    'mybookings.header': 'Менің брондарым',
    'mybookings.paid': 'ТӨЛЕНДІ',
    'mybookings.prepay': 'АЛДЫН АЛА ТӨЛЕМ',
    'mybookings.change': 'Өзгерту',
    'mybookings.cancel': 'Бас тарту',
    'mybookings.repeatAria': 'Сапарды қайталау',
    'mybookings.createNew': 'Жаңа брондау жасау',
    'mybookings.modalTitle': 'Брондауды менеджер арқылы өзгертуге болады',
    'mybookings.modalBody':
      'Сапарыңыздың мәліметтерін менеджермен бірге түзетіңіз. Ол бос нұсқаны таңдап, мәліметтерді қайта есептейді.',
    'mybookings.whatsapp': 'WhatsApp-қа жазу',
    'mybookings.hours': 'Күн сайын байланыста: 10:00–22:00',
    'mybookings.close': 'Жабу',
    'mybookings.keepBooking': 'Брондауды қалдыру',
    'mybookings.showAll': 'Барлығын көрсету',
    'mybookings.collapse': 'Жию',

    'loyalty.cancelTitle': 'Жазылымды бас тартасыз ба?',
    'loyalty.cancelBody': 'Бас тартқаннан кейін пайдаланылмаған сапарлар мен клуб артықшылықтары қолжетімсіз болады.',
    'loyalty.yesCancelBtn': 'Иә, бас тарту',
    'loyalty.keepSubBtn': 'Жазылымды қалдыру',
    'loyalty.switchTitle': '{tier} жоспарына ауысасыз ба?',
    'loyalty.switchBody':
      'Жазылымды ауыстырғанда ағымдағы жоспардың пайдаланылмаған сапарлары мен артықшылықтары қолжетімсіз болады.',
    'loyalty.yesSwitchBtn': 'Иә, ауысу',
    'loyalty.keepCurrentBtn': 'Ағымдағыны қалдыру',
    'loyalty.hero': 'Адалдық клубы',
    'loyalty.untilNextTier': '{tier} деңгейіне дейін {n} сапар',
    'loyalty.pointsSub': '1 ұпай = 1 теңге',
    'bonus.updatedJustNow': 'Жаңартылды: дәл қазір',
    'bonus.updatedAt': 'Жаңартылды: {time}',
    'bonus.updatedOn': 'Жаңартылды: {date}, {time}',
    'bonus.staleFailed': 'Деректер {when} бойынша · Жаңарту мүмкін болмады',
    'bonus.staleOld': 'Деректер {when} бойынша · Ескірген болуы мүмкін',
    'bonus.unavailable': 'Баланс алу мүмкін болмады',
    'bonus.notFound': 'Бонус шоты табылмады',
    'bonus.ambiguous': 'Бонус шотыңызды нақты анықтау мүмкін болмады. Клуб әкімшісіне хабарласыңыз.',
    'bonus.noWallet': 'Бонус бағдарламасы қосылмаған',
    'bonus.multiple': 'Бірнеше бонус бағдарламасы қосылған',
    'bonus.noPhone': 'Профильде телефон нөмірін көрсетіңіз',
    'bonus.spendAtCashier': 'Бонустарды клуб кассасында жұмсауға болады',
    'retention.fromClub': '888-ден хабарлама',
    'retention.open': 'Ашу',
    'retention.dismiss': 'Жабу',
    'retention.consentTitle': 'Еске салулар мен шақырулар',
    'retention.consentBody': '888-дің сирек еске салулары мен шақыруларын жіберейік пе? Профильде кез келген уақытта өшіруге болады.',
    'retention.consentYes': 'Иә, жіберіңіз',
    'retention.consentLater': 'Қазір емес',
    'bonus.rules': '1 бонус = 1 ₸ · 1% кешбэк · бонуспен 20%-ға дейін төлеуге болады',
    'bonus.pending.WELCOME': 'Сәлемдесу бонусы {amount} бонус есепке жазылуын күтуде',
    'bonus.pending.CASHBACK': '{amount} бонус кешбэк есепке жазылуын күтуде',
    'bonus.pending.REFUND': '{amount} бонус қайтарымы есепке жазылуын күтуде',
    'bonus.pending.REDEEM': '{amount} бонус есептен шығару өңделуде',
    'bonus.pending.ADJUSTMENT': '{amount} бонус түзетуі өңделуде',
    'bonus.kind.WELCOME': 'Сәлемдесу бонусы',
    'bonus.kind.CASHBACK': 'Кешбэк 1%',
    'bonus.kind.REDEEM': 'Бонуспен төлем',
    'bonus.kind.REFUND': 'Бонус қайтарымы',
    'bonus.kind.ADJUSTMENT': 'Түзету',
    'bonus.state.PENDING': 'Күтуде',
    'bonus.state.FAILED': 'Орындалмады',
    'bonus.state.BLOCKED': 'Тексеруді қажет етеді',
    'bonus.state.SKIPPED': 'Бұрын есепке жазылған',
    'bonus.state.CANCELLED': 'Бас тартылды',
    'bonus.redeem.available': 'Қолжетімді бонус',
    'bonus.redeem.upTo': 'Пайдалануға болады: {n} бонусқа дейін',
    'bonus.redeem.limit': 'құнының 20%-нан артық емес',
    'bonus.redeem.use': 'Бонусты есептен шығару',
    'bonus.redeem.payable': 'Төлем сомасы',
    'bonus.redeem.none': 'Есептен шығаруға бонус әзірге жоқ',
    'bonus.redeem.unavailable': 'Бонус балансын растау мүмкін болмады. Есептен шығару уақытша қолжетімсіз.',
    'bonus.redeem.ambiguous': 'Бонус шоты нақты анықталмады — есептен шығару қолжетімсіз.',
    'bonus.reserveFailed': 'Бонусты резервтеу мүмкін болмады. Қайталап көріңіз немесе бонуссыз төлеңіз.',
    'bonus.payWithoutBonus': 'Бонуссыз төлеу',
    'bonus.refresh': 'Жаңарту',
    'bonus.refreshing': 'Жаңартылуда…',
    'loyalty.historyBtn': 'Ұпайлар тарихы',
    'loyalty.historyEmpty': 'Әзірге ұпаймен операциялар жоқ',
    'loyalty.historyError': 'Тарихты жүктеу мүмкін болмады. Қайта көріңіз.',
    'loyalty.historyToday': 'Бүгін',
    'loyalty.historyYesterday': 'Кеше',
    'loyalty.historyPointsUnit': 'ұпай',
    'loyalty.activeSub': 'Белсенді жазылым',
    'loyalty.visitsRemaining': 'Қалған сапарлар',
    'loyalty.unlimited': 'Шексіз',
    'loyalty.daysRemaining': 'Қалған күндер',
    'loyalty.autoRenewOn': 'Автожаңарту қосулы',
    'loyalty.autoRenewAria': 'Автожаңарту',
    'loyalty.cancelSubBtn': 'Жазылымнан бас тарту',
    'loyalty.subscriptions': 'Клуб жазылымдары',
    'loyalty.perMonth': ' · ай',
    'loyalty.currentPlan': 'Ағымдағы жоспар',
    'loyalty.choose': 'Таңдау',
    'loyalty.faqTitle': 'Жиі қойылатын сұрақтар',
    'loyalty.faq.q1': 'Бонустар қалай есептеледі?',
    'loyalty.faq.a1':
      'Бонустар әр төленген сапардан кейін автоматты түрде есептеледі — пайызы чек сомасы мен клуб мәртебеңізге байланысты.',
    'loyalty.faq.q2': 'Бонустарды қалай пайдалануға болады?',
    'loyalty.faq.a2':
      'Ұпаймен сапардың бір бөлігін немесе клуб жазылымын төлеуге болады — ауыстырғыш рәсімдеу кезінде пайда болады.',
    'loyalty.faq.q3': 'Менің деңгейім қашан жаңарады?',
    'loyalty.faq.a3':
      'Деңгей (Silver/Gold/Platinum) әр сапардан кейін жалпы сапар санына негізделіп автоматты түрде қайта есептеледі.',
    'loyalty.faq.q4': 'Жазылымға не кіреді?',
    'loyalty.faq.a4':
      'Әр тариф айына белгілі бір сапар санын (немесе шексіз), жеңілдіктер мен сапар үшін бонустар береді — толық ақпарат тариф картасында.',
    'loyalty.faq.q5': 'Жазылым бойынша сапарлар қашан есептен шығарылады?',
    'loyalty.faq.a5': 'Сапар клубқа барған сәтте есептен шығарылады, егер ол тарифіңізде қарастырылған болса.',
    'loyalty.faq.q6': 'Жазылымды бонустармен төлеуге бола ма?',
    'loyalty.faq.a6':
      'Иә, қолжетімді ұпайларды рәсімдеу кезінде қолдануға болады — төлем экранындағы «Ұпайларды пайдалану» ауыстырғышы.',
    'loyalty.faq.q7': 'Жазылымнан бас тартсам не болады?',
    'loyalty.faq.a7': 'Пайдаланылмаған сапарлар мен клуб артықшылықтары бас тартқаннан кейін бірден қолжетімсіз болады.',
    'loyalty.faq.q8': 'Автожаңартуды қалай қосу/өшіру керек?',
    'loyalty.faq.a8': '«Автожаңарту» ауыстырғышы осы экрандағы белсенді жазылым картасында орналасқан.',
    'loyalty.faq.q9': 'Жазылымды өзгертуге бола ма?',
    'loyalty.faq.a9':
      'Иә, төмендегі тізімнен басқа тарифті таңдаңыз — жоспарды ауыстырғанда ағымдағы артықшылықтардың жойылатыны туралы ескертеміз.',

    'activity.badge.high': 'ЖОҒАРЫ',
    'activity.heading.high': 'Сіздің қалпына келу ырғағыңыз қазір жоғары.',
    'activity.body.high': 'Оны қолдау үшін 5–7 күн ішінде оралуды ұсынамыз.',
    'activity.badge.medium': 'ОРТАША',
    'activity.heading.medium': 'Сіздің қалпына келу ырғағыңыз қазір орташа.',
    'activity.body.medium': 'Оны жақсарту үшін 3–5 күн ішінде оралуды ұсынамыз.',
    'activity.badge.low': 'ТӨМЕН',
    'activity.unknownBadge': 'ДЕРЕК ЖОҚ',
    'activity.unknownHeading': 'Сіздің сапарларыңыз әлі көрінбейді.',
    'activity.unknownBody': 'Қабылдауда қолданбадағы телефон нөміріңізді айтыңыз — сапарларыңызды байланыстырамыз, осында ырғағыңыз пайда болады.',
    'activity.heading.low': 'Сіздің қалпына келу ырғағыңыз қазір төмен.',
    'activity.body.low': 'Оны қалпына келтіру үшін мүмкіндігінше тезірек оралуды ұсынамыз.',
    'activity.infoText1': 'Ырғақ соңғы 3 айдағы сапарларыңызға негізделген.',
    'activity.infoText2': 'Тұрақты сапарлар жоғары қалпына келу деңгейін сақтауға көмектеседі.',
    'activity.infoAria': 'Толығырақ',
    'activity.hero': 'Қалпына келу ырғағы',
    'activity.visits3moLine1': 'СОҢҒЫ 3 АЙДАҒЫ',
    'activity.visits3moLine2': 'САПАР',
    'activity.currentStreakLine1': 'АҒЫМДАҒЫ',
    'activity.currentStreakLine2': 'СЕРИЯ',
    'activity.totalVisitsLine1': 'БАРЛЫҚ',
    'activity.totalVisitsLine2': 'САПАР',
    'activity.thisWeekSuffix': 'осы аптада. Солай жалғастырыңыз!',
    'activity.personalRec': 'ЖЕКЕ ҰСЫНЫС',
    'activity.personalRecText': 'Сіздің тарихыңызға сай ең жақсы нұсқа — «{program}» бағдарламасы',
    'activity.recommendationsTitle': 'Қалпына келу үшін ұсыныстар',
    'activity.allPrograms': 'Барлық қалпына келу бағдарламалары',
    'activity.visits.many': '{n} сапар',
    'activity.visits.one': '{n} сапар',
    'activity.visits.few': '{n} сапар',
    'activity.recoverySuffix': 'қалпына келу',
    'activity.and': ' және ',

    'profile.subActive': 'БЕЛСЕНДІ ЖАЗЫЛЫМ',
    'profile.subExpiring': 'ЖАЗЫЛЫМ ЖАҚЫНДА АЯҚТАЛАДЫ',
    'profile.subExpired': 'ЖАЗЫЛЫМ АЯҚТАЛДЫ',
    'profile.visitsRemaining': 'қалған сапарлар',
    'profile.daysRemaining': 'қалған күндер',
    'profile.expiredBody': 'Клуб шарттарымен қайта сапар мен бағдарлама брондау үшін жазылымды жаңартыңыз.',
    'profile.autoRenewOn': 'Автожаңарту қосулы',
    'profile.autoRenewAria': 'Автожаңарту',
    'profile.renew': 'Жаңарту',
    'profile.visitFallback': 'Сапар',
    'profile.guestsSuffix': '{n} қонақ',
    'profile.pastVisit': 'ӨТКЕН САПАР',
    'profile.repeatAria': 'Сапарды қайталау',
    'profile.repeat': 'Қайталау',
    'profile.leaveReview': 'Пікір қалдыру',
    'profile.tile.personalInfo': 'Менің деректерім',
    'profile.tile.settings': 'Баптаулар',
    'profile.tile.feedback': 'Кері байланыс',
    'profile.tile.help': 'Көмек',
    'profile.tile.logout': 'Шығу',
    'profile.deleteTitle': 'Аккаунтты жоясыз ба?',
    'profile.deleteBody':
      'Аккаунт, сапарлар тарихы және бонустар жойылады. Жойғаннан кейін оларды қалпына келтіру мүмкін болмайды.',
    'profile.deleteConfirm': 'Аккаунтты жою',
    'profile.cancel': 'Бас тарту',
    'profile.notifications': 'Хабарландырулар',
    'profile.recoveryLabel': 'ҚАЛПЫНА КЕЛУ ЫРҒАҒЫ',
    'profile.bonusesLabel': 'БОНУСТАР',
    'profile.historyTitle': 'Сапарлар тарихы',
    'profile.upcomingTab': 'Алдағы',
    'profile.pastTab': 'Өткен',
    'profile.pay.paid': 'Төленді',
    'profile.pay.prepaid': 'Алдын ала төлем енгізілді',
    'profile.pay.unpaid': 'Төленбеді',
    'profile.pay.free': 'Төлемсіз',
    'profile.pay.pending': 'Төлем күтілуде',
    'profile.pay.declined': 'Төлем өтпеді',
    'profile.pay.button': 'Төлеу',
    'profile.pay.opening': 'Ашылуда…',
    'profile.pay.failed': 'Төлемді ашу мүмкін болмады. Қайталап көріңіз.',
    'profile.noUpcoming': 'Сізде әзірге алдағы сапарлар жоқ',
    'profile.noPast': 'Мұнда сапарларыңыздың тарихы көрсетіледі',
    'profile.loadMore': 'Тағы жүктеу',
    'profile.logoutTitle': 'Аккаунттан шығасыз ба?',
    'profile.logoutBody': 'Телефон нөміріңіз арқылы қайта кіре аласыз.',
    'profile.logoutConfirm': 'Қолданбадан шығу',
    'profile.deleteAccountAria': 'Аккаунтты жою',

    'profile.settings.bookingReminders': 'Брондау туралы еске салулар',
    'profile.settings.promoNews': 'Акциялар мен жаңалықтар',
    'profile.settings.appSection': 'Қолданба',
    'profile.settings.language': 'Тіл',
    'profile.settings.appVersion': 'Қолданба нұсқасы',

    'profile.help.title': 'Бізбен байланысу',
    'profile.help.faqTitle': 'Жиі қойылатын сұрақтар',
    'profile.help.faq.q1': 'Сапарды қалай брондауға болады?',
    'profile.help.faq.a1':
      '«Брондау» бөліміне өтіп, зал, күн және уақытты таңдаңыз — брондау төлемнен немесе алдын ала төлемнен кейін бірден расталады.',
    'profile.help.faq.q2': 'Брондауды қалай болдырмауға болады?',
    'profile.help.faq.a2':
      'Брондауды өзгерту немесе болдырмау менеджер арқылы жасалады — жоғарыда көрсетілген WhatsApp немесе телефон арқылы бізбен байланысыңыз.',
    'profile.help.faq.q3': 'Бонустарымды қайдан көремін?',
    'profile.help.faq.a3': 'Бонус балансы профильдің басты экранында және «Адалдық клубы» бөлімінде көрсетіледі.',
    'profile.help.faq.q4': 'Деңгей жүйесі қалай жұмыс істейді?',
    'profile.help.faq.a4':
      'Деңгей (Silver/Gold/Platinum) айдағы жалпы сапар санына сүйене отырып автоматты түрде қайта есептеледі.',
    'profile.help.faq.q5': 'Жазылымды қалай белсендіруге болады?',
    'profile.help.faq.a5':
      '«Адалдық клубы» бөлімінде тарифті таңдап, жазылымды рәсімдеңіз — ол төлемнен кейін бірден белсендіріледі.',

    'profile.feedback.title': 'Пікіріңізбен бөлісіңіз',
    'profile.feedback.intro':
      'Сізге не ұнағанын немесе нені жақсартуға болатынын айтыңыз. Біз пікірлерді мұқият оқып, клуб пен қызметті жақсарту үшін пайдаланамыз.',
    'profile.feedback.ratingLabel': 'Сіздің бағаңыз',
    'profile.feedback.starAria': '5-тен {n}',
    'profile.feedback.impressionLabel': 'Жалпы әсер',
    'profile.feedback.impressionPlaceholder': 'Сіздің пікіріңіз',
    'profile.feedback.recommendationsLabel': 'Сіздің ұсыныстарыңыз',
    'profile.feedback.recommendationsPlaceholder': 'Нені жақсартуға болады',
    'profile.feedback.sending': 'Жіберілуде…',
    'profile.feedback.submit': 'Жіберу',
    'profile.feedback.thanksTitle': 'Бөліскеніңізге рахмет',
    'profile.feedback.thanksBody':
      'Пікіріңіз бізге жетті. Біз мұндай хабарламаларға мұқият қараймыз — олар клубтың қамқорлығын, сапасын және атмосферасын сақтауға көмектеседі.',
    'profile.feedback.thanksBtn': 'Басты бетке',

    'profile.personalInfo.title': 'Жеке ақпарат',
    'profile.personalInfo.firstName': 'Аты',
    'profile.personalInfo.lastName': 'Тегі',
    'profile.personalInfo.notSet': 'Көрсетілмеген',
    'profile.personalInfo.genderMale': 'Ер',
    'profile.personalInfo.genderFemale': 'Әйел',
    'profile.personalInfo.saving': 'Сақталуда…',
    'profile.personalInfo.save': 'Өзгерістерді сақтау',

    'profile.notificationsEmpty': 'Сізде әзірге хабарламалар жоқ',
    'profile.languageTitle': 'Интерфейс тілін таңдаңыз',
    'profile.tierBase': 'Бастау',

    'booking.hall.title': 'Зал түрін таңдаңыз',
    'booking.hall.subtitle':
      'Демалыс форматын таңдаңыз: клубтың жалпы атмосферасында немесе жеке кеңістікте.',
    'booking.hall.standardTitle': 'Жалпы зал',
    'booking.hall.standardSubtitle': 'Классикалық атмосфера, банное компаниясы, ұжымдық рух',
    'booking.hall.vipTitle': 'VIP залы',
    'booking.hall.vipSubtitle': 'Жеке кеңістік, дербес шебер',
    'booking.hall.selectPrompt': 'Залды таңдаңыз',

    'booking.datetime.title': 'Күні мен уақыты',
    'booking.datetime.availableTime': 'Қолжетімді уақыт',
    'booking.datetime.noSlots': 'Қолжетімді слоттар жоқ',
    'booking.datetime.selectTime': 'Уақытты таңдаңыз',
    'booking.datetime.pickDate': 'Алдымен күнді таңдаңыз',
    'booking.datetime.loadError': 'Уақытты жүктеу мүмкін болмады. Қайталап көріңіз.',
    'booking.datetime.noSlotsToday': 'Бұл күнге бос уақыт жоқ',
    'booking.datetime.leadNote': 'Бронь басталуына кемінде {n} минут қалғанда ғана мүмкін',
    'booking.datetime.duration': 'Неше сағатқа',
    'booking.datetime.hoursShort': '{n} сағ',
    'booking.guests.maxTotal': 'Бір бронда ең көбі {n} адам (ересектер мен балалар)',
    'booking.program.skip': 'Қызметсіз жалғастыру',
    'booking.review.noExtras': 'Қосымша қызметсіз',
    'booking.review.hallCost': 'Залды жалға алу',
    'booking.review.burnNote': 'Бронь басталуына 3 сағаттан аз қалса, төлем қайтарылмайды — толық төлем де, алдын ала төлем де.',

    'booking.guests.title': 'Қанша қонақ болады?',
    'booking.guests.adults': 'Ересектер',
    'booking.guests.children': 'Балалар',
    'booking.guests.fewerAdults': 'Ересектерді азайту',
    'booking.guests.moreAdults': 'Ересектерді көбейту',
    'booking.guests.fewerChildren': 'Балаларды азайту',
    'booking.guests.moreChildren': 'Балаларды көбейту',
    'booking.guests.maxAdults': 'Максимум {n} қонақ',
    'booking.guests.maxChildren': 'Максимум {n} бала',

    'booking.program.title': 'Қалпына келу бағдарламасын немесе жеке қызметтерді таңдаңыз',
    'booking.program.tabPrograms': 'Бағдарламалар',
    'booking.program.tabServices': 'Қызметтер',
    'booking.program.empty': 'Бағдарламалар әлі қосылмаған',
    'booking.program.hit': 'ХИТ',
    'booking.program.vipHallBadge': 'VIP ЗАЛЫ',
    'booking.program.servicesEmpty': 'Қызметтер табылмады',
    'booking.program.categoryAll': 'Барлығы',
    'booking.program.selectProgram': 'Бағдарламаны таңдаңыз',
    'booking.program.selectServices': 'Қызметтерді таңдаңыз',
    'booking.program.minutesShort': 'мин',
    'booking.program.vipModalTitle': 'Бағдарлама VIP залында қолжетімді',
    'booking.program.vipModalBody':
      '«{name}» дербес шебермен жеке форматта өткізіледі, сондықтан тек VIP залын таңдағанда қолжетімді.',
    'booking.program.ok': 'Жарайды',
    'booking.program.changeHall': 'Залды өзгерту',
    'booking.program.selectedOne': '{n} қызмет таңдалды',
    'booking.program.selectedFew': '{n} қызмет таңдалды',
    'booking.program.selectedMany': '{n} қызмет таңдалды',

    'booking.review.title': 'Мәліметтерді тексеріңіз',
    'booking.review.payFull': '100% төлеу',
    'booking.review.payPrepayment': 'Алдын ала төлем енгізу',
    'booking.review.payModeSubscription': 'Жазылымнан есептен шығару',
    'booking.review.subVisitsRemainingPrefix': 'Қалды',
    'booking.review.subVisitsRemainingCount': '{n} сапар',
    'booking.review.payModeSeparate': 'Бөлек төлеу',
    'booking.review.payModeSeparateNote':
      'Толық төлеуге немесе жалпы соманың 30% мөлшерінде алдын ала төлем енгізуге болады',
    'booking.review.subscriptionRedeemNote': 'Жазылымнан 1 сапар есептен шығарылады',
    'booking.review.subscriptionRedeemNoteDiscount':
      'Жазылымнан 1 сапар есептен шығарылады — бағдарлама мен қызметтерге {percent}% жеңілдік',
    'booking.review.managerSheetTitle': 'Есептен шығару менеджер арқылы қолжетімді',
    'booking.review.managerSheetBullet1':
      '2 және одан да көп адамға брондау кезінде сапарды қосымша ішінде жазылымнан есептен шығару мүмкін емес.',
    'booking.review.managerSheetBullet2':
      'Қазір тапсырысты толық төлеуге немесе кепілпұл енгізуге болады. Өтінім жіберілгеннен кейін менеджер сізбен байланысады, сапарды жазылымнан есептен шығарады және қосымша төлем сомасын есептейді.',
    'booking.review.managerSheetGotIt': 'Түсінікті',
    'booking.review.paymentNote':
      'Барлық соманы қазір төлеуге немесе 30% алдын ала төлем енгізуге болады. Қалғаны орнында немесе менеджер арқылы төленеді.',
    'booking.review.hallLabel': 'Зал',
    'booking.review.dateLabel': 'Күні',
    'booking.review.timeLabel': 'Уақыты',
    'booking.review.guestsLabel': 'Қонақтар',
    'booking.review.programLabel': 'Бағдарлама',
    'booking.review.totalLabel': 'Төленетін сома',
    'booking.review.hallStandard': 'Жалпы зал',
    'booking.review.hallVip': 'VIP залы',
    'booking.review.guestsWord': 'адам',
    'booking.review.childrenSuffix': ', {n} бала',
    'booking.review.promoPlaceholder': 'Промокодты енгізіңіз',
    'booking.review.useBonus': 'Пайдалану',
    'booking.review.bonusPoints': '{n} ұпай',
    'booking.review.useBonusAria': 'Бонус ұпайларын пайдалану',
    'booking.review.submitting': 'Жіберілуде…',
    'booking.review.submit': 'Төлемге өту',

    'booking.payment.checking': 'Төлем тексерілуде…',
    'booking.payment.checkError':
      'Төлем мәртебесін тексеру мүмкін болмады. Ақша есептен шығарылған болса, клубқа хабарласыңыз.',
    'booking.payment.successTitle': 'Төлем сәтті өтті',
    'booking.payment.pendingTitle': 'Брондау жасалды',
    'booking.payment.declinedTitle': 'Төлем қабылданбады',
    'booking.payment.successBody': 'Сапарыңыздың мәліметтерін сақтадық. Клубта кездескенше!',
    'booking.payment.pendingBody':
      'Төлемді растап жатырмыз — бұл бірнеше минутқа созылуы мүмкін. Қажет болса, сізбен байланысамыз.',
    'booking.payment.declinedBody': 'Төлем өтпеді. Қайталап көріңіз немесе клубқа хабарласыңыз.',
    'booking.payment.done': 'Дайын',
    'booking.payment.redirecting': 'Төлемге өтудеміз…',
    'booking.payment.notCompletedTitle': 'Төлем аяқталмады',
    'booking.payment.notCompletedBody': 'Брондау сақталды, бірақ төлем өтпеді. Қайта көруге болады.',
    'booking.payment.retry': 'Қайталап көру',
    'booking.payment.close': 'Жабу',

    'club.addressLabel': 'Мекенжай',
    'club.addressLine1': 'Жанайдар Жирентаев көшесі, 3',
    'club.addressLine2': 'Алматы ауданы, Астана, Z00Y3E8',
    'club.hoursLabel': 'Жұмыс уақыты',
    'club.hoursLine1': 'дс: 12:00–22:00',
    'club.hoursLine2': 'сс-жм: 11:00–22:00',
    'club.hoursLine3': 'сб-жс: 10:00–22:00',
    'club.description':
      'Club 888 — үйдегідей баня, мұнда өзіңе қамқорлық жасау тұрақты рәсімге айналады. ' +
      '2010 жылдан бері дұрыс бу, жылу және мұқият сервис арқылы кеңістік жасаймыз. ' +
      'Бұл — қарбалас күннен кейін қалпына келетін, жақындарыңызбен уақыт өткізетін және өзіңізге оралатын орын.',
    'club.powerCardTitle': 'Күш орны',
    'club.powerCardBody':
      'Бізге денені қалпына келтіру, бас қалаудан арылу және жылы, тыныш атмосферада уақыт өткізу үшін келеді.',
    'club.atmosphereBadge': 'КЛУБ АТМОСФЕРАСЫ',
    'club.directionsTitle': 'Бізге қалай жетуге болады',
    'club.buildRoute': 'Бағыт құру',
    'club.contactsTitle': 'Байланыстар',
    'club.whatsapp': 'WhatsApp-қа жазу',
    'club.recordsTitle': 'Клуб рекордтары',
    'club.numbersTitle': '888 сандармен',
    'club.storiesTitle': 'Осында басталған оқиғалар',
    'club.estimatedNote': 'Бағалау көрсеткіштері — клуб жұмыс уақыты бойынша есептелген',
    'club.noData': 'Дерек жоқ',
    'club.num.years': 'Тарих жылдары',
    'club.num.rating': 'Клуб рейтингі',
    'club.num.guests': 'Айдағы қонақтар',
    'club.num.guestsTotal': 'Барлық қонақтар',
    'club.num.hours': 'Қалпына келтіру сағаттары',
    'club.num.steamings': 'Жасалған бу рәсімдері',
    'club.num.kvas': 'Ішілген квас, л',
    'club.cat.business': 'Бизнес',
    'club.cat.acquaintance': 'Танысу',
    'club.cat.likeminded': 'Пікірлестер',
    'club.cat.family': 'Отбасы',
    'club.cat.recovery': 'Демалыс',
  },
};

function resolveInitialLanguage() {
  // Flutter bakes the current language into the URL hash on every load —
  // `#lang=kk` (and `&token=...` alongside it), same mechanism as the auth
  // token — so it's available synchronously on first paint, before any
  // postMessage could arrive. See full_page_webview.dart's _buildUri.
  const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ''));
  const hashLang = hashParams.get('lang');
  if (hashLang === 'ru' || hashLang === 'kk') return hashLang;

  const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  if (stored === 'ru' || stored === 'kk') return stored;

  return 'ru';
}

function postToFlutter(action, payload) {
  if (window.FlutterBridge) {
    window.FlutterBridge.postMessage(JSON.stringify({ action, payload }));
  }
}

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(resolveInitialLanguage);

  const setLanguage = useCallback((lang) => {
    setLanguageState(lang);
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
    // Mirrors the choice back to Flutter, which persists it, updates its
    // own chrome (bottom nav labels), and re-broadcasts it to every other
    // already-loaded tab — see home_placeholder_screen.dart's
    // `set_language` bridge handler and FullPageWebView's `language` prop.
    postToFlutter('set_language', { lang });
  }, []);

  useEffect(() => {
    function handleMessage(event) {
      const lang = event.data?.type === 'SET_LANGUAGE' ? event.data.lang : null;
      if (lang === 'ru' || lang === 'kk') {
        setLanguageState(lang);
        localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
      }
    }
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  const t = useCallback(
    (key, vars) => {
      const dict = translations[language] || translations.ru;
      const raw = dict[key] ?? translations.ru[key] ?? key;
      return interpolate(raw, vars);
    },
    [language],
  );

  // For backend content, not static UI strings: the API now sends both the
  // Russian field and an admin-filled `<field>_kk` counterpart (e.g.
  // `name` + `name_kk`) for catalog content — services, recovery programs,
  // loyalty tiers, the "dramaturg of the day" event, announcements,
  // masters, and legal-document sections. This picks whichever the current
  // language needs, falling back to the Russian field whenever the admin
  // hasn't typed a Kazakh version yet (or the object doesn't carry one).
  // Usage: localize(service, 'name') instead of service.name.
  const localize = useCallback(
    (obj, field) => {
      if (!obj) return obj?.[field];
      if (language === 'kk') {
        const kk = obj[`${field}_kk`];
        if (kk) return kk;
      }
      return obj[field];
    },
    [language],
  );

  const value = useMemo(
    () => ({ language, setLanguage, t, localize }),
    [language, setLanguage, t, localize],
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within a LanguageProvider');
  return ctx;
}
